import { Injectable } from '@angular/core';


@Injectable({
  providedIn: 'root',
})
export class RoleGuardService  {

  constructor(
  ) {
  }

  canActivate() {
    return true;
  }
}
